<template>
<div>
  <table>
    <thead>
      <th class="vertical-align-bottom text-left text-capitalize"></th>
      <th
        class="vertical-align-bottom text-capitalize d-sm-table-cell d-none"
        v-for="(column, index) in columns"
        :key="index"
      >
        {{ column }}<span v-if="column === 'district'">/Charter</span>
        <div
          v-if="showAgreeBreakout"
          class="text-caption grey--text text--darken-1"
        >
          agree | total
        </div>
      </th>
    </thead>
    <tr v-for="question in questions" :key="question.key">
      <td class="w-100 ">
        <div class="py-3 py-sm-0 d-flex align-start">
          <span
            class="mr-3"
            v-if="question.questionNumber && question.questionNumber.length > 0"
          >
            {{ question.questionNumber }}
          </span>
          <survey-question-text :text="question.text"></survey-question-text>
        </div>
        <div class="d-sm-none" v-for="(column, index) in columns" :key="index">
          <v-divider
            v-if="index === 0"
            :class="{ 'mt-3': index === 0 }"
          ></v-divider>
          <div class="d-flex align-center pa-2">
            <div class="flex-fill font-weight-bold">
              {{ column }}
              <div
                v-if="showAgreeBreakout"
                class="text-caption grey--text text--darken-1"
              >
                agree | total
              </div>
            </div>
            <div>
              <comparison-button
                :results="question.results[column]"
              ></comparison-button>
            </div>
          </div>

          <v-divider
            :class="{ 'mb-5': index === columns.length - 1 }"
          ></v-divider>
        </div>
      </td>
      <td
        v-for="(column, index) in columns"
        :key="index"
        class="text-right d-sm-table-cell d-none"
      >
        <comparison-button
          :results="question.results[column]"
        ></comparison-button>
      </td>
    </tr>
  </table>
  <v-alert
      dense
      type="primary"
      class="mt-5"
      v-if="questionKey === 'PLS1' || questionKey === 'IN1'"
    >
      <div v-if="questionKey === 'PLS1'">*To see what professional development needs your teachers have, please go to the Item Analysis Report for your school or district.</div>
      <div v-else>*To see what instructional supports needs your teachers have, please go to the Item Analysis Report for your school or district.</div>      
    </v-alert>

</div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  td {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import ComparisonButton from "./Results.AgreeAnalysis.ComparisonButton.vue";
import SurveyQuestionText from "../../../components/Survey.Question.Text.vue";

export default {
  components: { ComparisonButton, SurveyQuestionText },
  data: () => ({}),
  props: {
    questions: Array,
    questionKey: String,
    showAgreeBreakout: Boolean
  },
  computed: {
    columns() {
      let results = [];

      this.questions.forEach(x => {
        for (let key in x.results) {
          if (!results.some(x => x === key)) {
            results.push(key);
          }
        }
      });

      return results;
    }
  }
};
</script>
